<template>
  <div>
    <div class="row">
      <div class="col-12 col-md-8">
        <template v-for="(component, index) of content.column1" :key="index">
          <WidgetModel :component="component"></WidgetModel>
        </template>
      </div>
      <div class="col-12 col-md-4">
        <template v-for="(component, index) of content.column2" :key="index">
          <WidgetModel :component="component"></WidgetModel>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import WidgetModel from '@/components/Widgets/Shared/WidgetModel.vue';

export default {
  name: "AppLayout_8_4",
  data() {
    return {
      content: this.$route.meta && this.$route.meta.layout && this.$route.meta.layout.content  ? this.$route.meta.layout.content : '',
    };
  },
  components: {
    WidgetModel,
  },

}
</script>

<style scoped>
  .header {
    height: 5rem;
    background-color: green;
  }
</style>